<button class="field" type="button" [id]="name()" [disabled]="disabled()" (click)="pressed.emit()">
    <span class="value">
        @if (text()) {
            @if (icon()) {
                <mat-icon class="icon" [svgIcon]="icon()" />
            } @else if (treeIcon()) {
                <app-cerrix-tree-icon-viewer
                    [icon]="treeIcon()"
                    appendClass="fa-fw me-1"
                ></app-cerrix-tree-icon-viewer>
            }
            <span class="text">{{ text() }}</span>
        } @else {
            <span class="placeholder">{{ placeholder() }}</span>
        }
    </span>
    <mat-icon class="add" svgIcon="add" aria-hidden="true" />
</button>
